import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, Card, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { default as React, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "../../config/axios";
import Style from "../../css/login.module.scss";



export default function Login() {
  const [credentials, setCredentials] = useState({ mobile: "", password: "" })
  const navigate = useNavigate()

  const [showPassword, setShowPassword] = useState(false)

  const handleOnChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    let res = await axios.post(`/api/login`, {
      mobile: credentials.mobile,
      password: credentials.password
    })

    console.log("login api res ==================>", res);

    let data = await res.data;

    if (data.status_code == 200) {
      await localStorage.setItem('token', JSON.stringify(data.jwt));
      navigate("/");
      // setTimeout(()=>{
        window.location.reload()
      // },1000)
      
    }
    else alert("Invalid credentials");
  };


  return (
    <>
      <form onSubmit={handleSubmit}>
        <Box className={Style.login}>
          <Card className={Style.login_} sx={{ p: 3 }}>
            <img width='80px' src='/assets/logo.png' />
            <Stack sx={{ mt: 2 }} alignItems='center' spacing={1}>
              <Typography variant='h6'>Login</Typography>
              <Typography variant='h5' color='primary'>Voucher Admin Panel</Typography>
            </Stack>
            <Stack sx={{ mt: 2, width: '100%' }} spacing={2}>
              <TextField label='email' fullWidth type="text" value={credentials.mobile} onChange={handleOnChange} name='mobile' placeholder="please enter mobile number" />
              <FormControl variant="outlined">
                <InputLabel>Password</InputLabel>
                <OutlinedInput
                  value={credentials.password}
                  name='password'
                  onChange={handleOnChange}
                  type={showPassword ? 'text' : 'password'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {!showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
                {/* <FormHelperText error="error">{errors?.password?.message}</FormHelperText> */}
              </FormControl>
              <Button fullWidth variant='contained' type="submit">Login</Button>
            </Stack>
          </Card>
        </Box>
      </form>
    </>
  );
}
